const text = value => value == null ? '' : String(value).trim()

export function needsOperatorName (item) {
  return !text(item.operatorName) || ['未知用户', '姓名未设置'].includes(text(item.operatorName))
}

// 兼容尚未返回姓名的旧日志接口；账号只作为关联依据，不作为操作人显示内容。
export function withOperatorNames (items, users) {
  const byId = new Map(); const byAccount = new Map()
  users.forEach(user => {
    const name = text(user.name) || text(user.displayName)
    if (name && text(user.id)) byId.set(text(user.id), name)
    if (name && text(user.account)) byAccount.set(text(user.account), name)
  })
  return items.map(item => {
    if (!needsOperatorName(item)) return item
    const id = text(item.operatorId) || text(item.userId) || text(item.ownerId)
    const name = id ? byId.get(id) : byAccount.get(text(item.operatorAccount) || text(item.account))
    return { ...item, operatorName: name || text(item.operatorName) || '未知用户' }
  })
}
